<ng-container *transloco="let t; prefix: 'trip-finances.panels.online-donation'">
  <app-panel-body>
    <div class="flex min-h-0 flex-1 flex-col">
      <div class="min-h-0 flex-1 overflow-y-auto">
        <app-content-container>
          @if (record(); as donation) {
            <div class="space-y-4">
              <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
                <div>
                  <div class="text-xs text-primary-text-light">{{ t('date') }}</div>
                  <div class="font-medium">{{ donation.date | date:'mediumDate' }}</div>
                </div>
                <div>
                  <div class="text-xs text-primary-text-light">{{ t('amount') }}</div>
                  <div class="font-medium">{{ donation.amount | currency }}</div>
                </div>
                <div>
                  <div class="text-xs text-primary-text-light">{{ t('name') }}</div>
                  <div class="font-medium">{{ donation.name }}</div>
                </div>
                <div>
                  <div class="text-xs text-primary-text-light">{{ t('email') }}</div>
                  <div class="font-medium">{{ donation.email || '—' }}</div>
                </div>
              </div>

              @if (donation.note) {
                <div>
                  <div class="text-xs text-primary-text-light">{{ t('note') }}</div>
                  <div class="text-sm">{{ donation.note }}</div>
                </div>
              }

              <app-participant-assignment-editor
                [totalAmount]="donation.amount"
                [(assignEnabled)]="assignEnabled"
                [(links)]="links"
                [roster]="roster()"
              />
            </div>
          }
        </app-content-container>
      </div>

      <div class="flex shrink-0 justify-end gap-3 border-t border-primary-border px-4 py-4">
        <button type="button" class="rounded-md border border-primary-border px-4 py-2 text-sm font-semibold" (click)="cancel()" [disabled]="submitting()">
          {{ t('cancel') }}
        </button>
        <button type="button" class="btn btn-primary btn-no-grow disabled:opacity-50" (click)="save()" [disabled]="submitting() || !assignmentValid()">
          {{ t('save') }}
        </button>
      </div>
    </div>
  </app-panel-body>
</ng-container>
